import React, { useEffect, useState, Fragment, useMemo } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Popconfirm, Select, Drawer, notification, Tooltip,
  Divider,
} from 'antd';
import {
  FallOutlined, RiseOutlined,
} from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlugCircleXmark, faPowerOff, faPlay, faPause, faStop, faCircleExclamation, faClock, faIndustry, faUser,
  faAnglesRight,
} from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import JobWorkActions from '@Actions/production/jobWorkActions';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TemplateRouteActions from '@Actions/production/templateRouteActions';
import Helpers from '@Apis/helpers';
import Stopwatch from '@Components/Common/StopWatch';
import { toISTDate } from '@Apis/constants';
import SelectUser from '@Components/Common/SelectUser';
import SelectSeller from '@Components/Common/SelectSeller';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import PRZModal from '../../../Common/UI/PRZModal';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import ListScreenKeys from './mobileListHelper';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';

const { Option } = Select;

/**
 *
 */
function JobWorksList({
  user, selectedTenant, updateTemplateRouteStatusLoading, updateTemplateRouteStatus,
  jobWorks, getJobWorksLoading, updateAssignee, updateAssigneeLoading,
  updateJobWork, updateJobWorkLoading, jobOperators,
  limit, setLimit, currentPage, setCurrentPage, call, setCall, selectedRowKeys, setSelectedRowKeys,
  setSelectedRows, setSelectedJobWork,

}) {
  const [showPRZModal, setShowPRZModal] = useState(false);
  const [currentProduct, setCurrentProduct] = useState({});

  const [selectedJob, setSelectedJob] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const machineStatus = (status) => {
    if (status === 'ONLINE') return { bgColor: 'rgba(47,188,110,0.0)', color: '#2fbc6e' };
    if (status === 'BREAKDOWN') return { bgColor: 'rgba(248,119,89,0.1)', color: '#FF5630FF' };
    if (status === 'OFFLINE') return { bgColor: 'rgba(248,119,89,0.1)', color: '#FF5630FF' };
    return { bgColor: '#335aa8' };
  };

  const getStatusColor = (status) => {
    if (status === 'COMPLETED') return { color: '#22C55EFF', text: 'Completed' };
    if (status === 'DRAFT') return { color: '#b0b0b0', text: 'Draft' };
    if (status === 'IN_PROGRESS') return { color: '#2d7cf7', text: 'In Progress' };
    if (status === 'PENDING') return { color: '#dcb106', text: 'Pending' };
    if (status === 'PAUSED') return { color: '#b0b0b0', text: 'Paused' };
    if (status === 'VOID') return { color: '#d2d2d2', text: 'Void' };
  };

  function convertMinutesToTime(minutes) {
    if (Number.isNaN(minutes) || minutes < 0) {
      return 'Invalid input';
    }

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = Math.floor((minutes % 60) / 1);
    const seconds = Math.round((minutes % 1) * 60);

    const formattedHours = hours > 0 ? (hours < 10 ? `0${hours}` : hours) : '00';
    const formattedMinutes = remainingMinutes > 0 ? (remainingMinutes < 10 ? `0${remainingMinutes}` : remainingMinutes) : '00';
    const formattedSeconds = seconds > 0 ? (seconds < 10 ? `0${seconds}` : seconds) : '00';

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  const JobWorkAction = ({ record }) => {
    // const timeElapsed = record?.status === 'IN_PROGRESS' ? (dayjs().diff(toISTDate(record?.started_at), 'millisecond') + (record?.total_time_elapsed_in_min * 60000)) / 10 : (record?.total_time_elapsed_in_min * 60000) / 10;
    const timeElapsed = useMemo(() => {
      dayjs.extend(utc);
      dayjs.extend(timezone);

      const currentISTTime = dayjs().tz('Asia/Kolkata');
      let time;
      if (record?.status === 'IN_PROGRESS') {
        time = currentISTTime.diff(toISTDate(record?.started_at || currentISTTime));
      } else if (record?.status === 'PAUSED') {
        time = dayjs(toISTDate(record?.last_paused_at)).diff(toISTDate(record?.started_at));
      } else {
        time = dayjs(toISTDate(record?.completed_at)).diff(toISTDate(record?.started_at));
      }
      time = Math.abs(time) / 10;

      return time;
    }, [record]);
    const estimatedTime = (Number(record?.target_quantity) / (Number(record?.machine?.prod_cap_per_hour) * Number(record?.machine?.ideal_time_efficiency)));
    const actualTime = ((timeElapsed * 10) / 3600000);
    return (
      <div className="job-work__actions__wrapper">
        <div className="job-work__actions">
          {['PENDING', 'DRAFT', 'COMPLETED', 'PAUSED', 'VOID'].includes(record?.status) && (
            <Popconfirm
              placement="topLeft"
              title="Are you sure you want to start the Job Card?"
              onConfirm={() => {
                if (!['IN_PROGRESS', 'DRAFT', 'COMPLETED', 'VOID'].includes(record?.status)) {
                  if (['OFFLINE', 'BREAKDOWN'].includes(record?.machine_resource_group?.allocated_machine?.status)) {
                    notification.open({
                      message: `Machine ${record?.machine_resource_group?.allocated_machine?.resource_number} ${record?.machine_resource_group?.allocated_machine?.resource_name} is currently in ${record?.machine_resource_group?.allocated_machine?.status?.toProperCase()} status.`,
                      description: 'Job Card cannot be started if the machine is not online',
                      placement: 'top',
                      duration: 6,
                      type: 'error',
                    });
                  } else if (record?.incomplete_previous_job_works?.length > 0 && Number(record?.pending_qty) <= 0 && record?.status !== 'COMPLETED') {
                    notification.open({
                      message: 'Job Card cannot be started as the previous Job Card is not yet completed.',
                      description: `${record?.incomplete_previous_job_works[0]?.jw_number} - ${record?.incomplete_previous_job_works[0]?.process_name}`,
                      placement: 'top',
                      duration: 10,
                      type: 'error',
                    });
                  } else {
                    const payload = {
                      production_route_line_ids: [record?.production_route_line_id],
                      status: 'IN_PROGRESS',
                    };
                    updateTemplateRouteStatus(payload, () => {
                      setCall(!call);
                    });
                  }
                }
              }}
              okText="Yes"
              cancelText="No"
              disabled={['IN_PROGRESS', 'DRAFT', 'COMPLETED', 'VOID'].includes(record?.status)}
            >
              <div
                className={`job-work__action-start ${['IN_PROGRESS', 'DRAFT', 'COMPLETED', 'VOID'].includes(record?.status) ? 'job-work__action-disabled' : ''}`}
              >
                <FontAwesomeIcon icon={faPlay} />
              </div>
            </Popconfirm>
          )}
          {['IN_PROGRESS'].includes(record?.status) && (
            <Popconfirm
              placement="topLeft"
              title="Are you sure you want to pause the Job Card?"
              onConfirm={() => {
                if (!['PENDING', 'DRAFT', 'COMPLETED', 'PAUSED', 'VOID'].includes(record?.status) && !record.subcontractor_seller_id) {
                  const payload = {
                    production_route_line_ids: [record?.production_route_line_id],
                    status: 'PAUSED',
                  };
                  updateTemplateRouteStatus(payload, () => {
                    setCall(!call);
                  });
                }
              }}
              okText="Yes"
              cancelText="No"
              disabled={['PENDING', 'DRAFT', 'COMPLETED', 'PAUSED', 'VOID'].includes(record?.status)}
            >
              <div
                className={`job-work__action-pause ${(['PENDING', 'DRAFT', 'COMPLETED', 'PAUSED', 'VOID'].includes(record?.status) || record.subcontractor_seller_id) ? 'job-work__action-disabled' : ''}`}
              >
                <FontAwesomeIcon icon={faPause} />
              </div>
            </Popconfirm>
          )}
          <Popconfirm
            placement="topLeft"
            title="Are you sure you want to stop the Job Card?"
            description="This Job Card will be marked as completed."
            onConfirm={() => {
              const payload = {
                production_route_line_ids: [record?.production_route_line_id],
                status: 'COMPLETED',
              };
              updateTemplateRouteStatus(payload, () => {
                setCall(!call);
              });
            }}
            okText="Yes"
            cancelText="No"
            disabled={['PENDING', 'DRAFT', 'COMPLETED', 'VOID'].includes(record?.status)}
          >
            <div
              className={`job-work__action-stop ${(['PENDING', 'DRAFT', 'COMPLETED', 'VOID'].includes(record?.status) || (record?.mo_adjustment_id && Number(record?.pending_qty) > 0)) ? 'job-work__action-disabled' : ''}`}
            >
              <FontAwesomeIcon icon={faStop} />
            </div>
          </Popconfirm>
        </div>
        <div className="job-work__actions-timer">
          {
            record?.status === 'COMPLETED' && record?.machine?.prod_cap_per_hour > 0 && (
              <div style={{ fontSize: '11px', fontWeight: '600', width: '70px' }}>
                {actualTime > estimatedTime ? (
                  <span style={{ color: '#EE404C' }}>
                    <RiseOutlined />
                    &nbsp;
                    {`${(((actualTime - estimatedTime) / estimatedTime) * 100)?.toFixed(2)}%`}
                  </span>
                ) : (
                  <span style={{ color: '#1AC05D' }}>
                    <FallOutlined />
                    &nbsp;
                    {`${(((estimatedTime - actualTime) / estimatedTime) * 100)?.toFixed(2)}%`}
                  </span>
                )}

              </div>
            )
          }
          {getJobWorksLoading || !record?.started_at ? '__:__:__'
            : (user?.tenant_info?.production_config?.sub_modules?.manufacturing_order?.settings?.enable_time_tracking_in_job_cards && <Stopwatch isRunning={record?.status === 'IN_PROGRESS'} timeElapsed={timeElapsed || 0} />)}
        </div>
      </div>
    );
  };

  const OperatorSelector = ({ record }) => {
    const selectedUsers = record?.assignees?.map((assignee) => ({
      userId: assignee?.user_id,
      title: assignee?.first_name,
      identity: assignee?.identity,
    }));

    return (
      <SelectUser
        tenantId={selectedTenant?.join(',')}
        selectedUsers={selectedUsers}
        disabled={['COMPLETED'].includes(record?.status)}
        userList={jobOperators?.find((item) => item?.tenant_id === record?.tenant_info?.tenant_id)?.users}
        onSelect={(userId) => {
          setCurrentPage(1)
          updateJobWork([
            {
              production_route_line_id: record?.production_route_line_id,
              production_route_id: record?.production_route_id,
              resources: record?.machine_resource_group?.resource_group_id ? [
                {
                  resource_group_id: record?.machine_resource_group?.resource_group_id,
                  resource_ids: record?.machine_resource_group?.allocated_machine?.resource_id ? [record?.machine_resource_group?.allocated_machine?.resource_id] : [],
                },
              ] : [],
              assignees: [Number(userId) > 0 ? userId : null],
            },
          ], () => setCall(!call));
        }}
        onRemove={(userId) => {
          updateAssignee([
            {
              production_route_line_id: record?.production_route_line_id,
              assignees: [...record?.assignees?.map((assignee) => (assignee?.user_id))?.filter((item) => item != userId)],
            },
          ], () => {
            setCall(!call);
          });
        }}
        singleSelect
      />
    );
  };

  const getJobWorkColumns = () => {
    const mobileViewColumn = {
      title: 'Job Card#',
      render: (record) => {
        return (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <Link
                // to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
                >
                  <PRZText
                    text={`#${record?.jw_number || ''}`}
                    className="mobile-list__card_item-number"
                  />
                </Link>
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  className="mobile-list__card__status"
                  style={{
                    backgroundColor: getStatusColor(record?.status).color,
                  }}
                  text={getStatusColor(record?.status).text?.toUpperCase()}
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <div className="mobile-list__card_item-name_wrapper">
                  <Tooltip
                    title={
                      Helpers.getPermission(Helpers.permissionEntities.MO,
                        Helpers.permissionTypes.READ, user)
                        ? (
                          <Link
                          // to={`/production/manufacturing-orders/view/${record?.mo_id} target="_blank"
                          >
                            <PRZText
                              className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                              text={record?.mo_number}
                            />
                          </Link>
                        ) : (
                          <PRZText
                            className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                            text={record?.mo_number}
                          />
                        )
                    }
                    color="white"
                  >
                    <PRZText text={`Order# ${record?.mo_number}`} className="mobile-list__card_item-name" />
                  </Tooltip>
                </div>

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${record?.tenant_info?.tenant_name} (${record?.department_name})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Location: ${record?.tenant_info?.tenant_name} (${record?.department_name})`} className="mobile-list__card_item-details" />
                </Tooltip>

                <PRZText
                  text={(
                    <span style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                    >
                      <span>Operator:</span>
                      <OperatorSelector record={record} />
                    </span>
                  )}
                  className="mobile-list__card_item-details"
                />

                <PRZText text={`No. of Man Power: ${record.no_of_man_power ? record.no_of_man_power : '-'}`} className="mobile-list__card_item-details" />

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${dayjs(record?.created_at).format('DD/MM/YYYY')} ( ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Created By ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'} on ${dayjs(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details created_by_info" />
                </Tooltip>

              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Estimated Lead Time" />
                  )}
                >
                  <PRZText
                    text={(record?.lead_time_in_min ? `${convertMinutesToTime(record?.lead_time_in_min)}` : '00:00:00')}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>

              </div>
            </div>

            <Divider className="mobile-list__card_divider" />

            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Time Lapsed (Hours)" />
                  )}
                >
                  <JobWorkAction record={record} />

                </Tooltip>

              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedJob(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        );
      },
      // responsive: ['xs'],
      hidden: !isMobile,
    };
    const jobWorkColumns = [
      mobileViewColumn,
      {
        title: 'Job Card#',
        render: (record) => (
          <div className="column-number__wrapper min-width-70">
            <div>
              {record?.jw_number || ''}
            </div>
            <div className="qr__status" style={{ backgroundColor: getStatusColor(record?.status).color }}>
              {getStatusColor(record?.status).text?.toUpperCase()}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        fixed: 'left',
      },
      {
        title: 'Order#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-70">
            <div className="company__name" style={{ fontWeight: '600' }}>
              {Helpers.getPermission(Helpers.permissionEntities.MO,
                Helpers.permissionTypes.READ, user)
                && (
                  <Link to={`/production/manufacturing-orders/view/${record?.mo_id}`} target="_blank">
                    {record?.mo_number}
                  </Link>
                  || '-')}
            </div>
            <div className="job-works__table-subtext">
              {record?.tenant_info?.tenant_name}
              <div>
                {record?.tenant_department_info?.department_name}
              </div>
            </div>
          </div>
        ),
        fixed: 'left',
      },
    ];
    const fixedColumn = [
      {
        title: 'Finished Good',
        render: (text, record) => {
          const productName = `#${record?.internal_sku_code} ${record?.product_sku_name}`;
          const estimatedLeadTime = `${record?.machine?.prod_cap_per_hour > 0 ? (qty / (Number(record?.machine?.prod_cap_per_hour) * Number(record?.machine?.ideal_time_efficiency)))?.toFixed(2) : '0'} Hours`;
          return (
            <div className="min-width-100">
              <Tooltip title={productName}>
                {Helpers.getPermission(Helpers.permissionEntities.PRODUCT,
                  Helpers.permissionTypes.READ, user)
                  && (
                    <div onClick={() => {
                      setShowPRZModal(true);
                      setCurrentProduct(record?.product_sku_id);
                    }}
                    >
                      <a>
                        {`#${productName?.length > 25 ? `${productName?.substring(0, 25)}...` : productName}`}
                      </a>
                    </div>
                    || '-')}
              </Tooltip>
              {record?.mo_adjustment_id && <H3Text text={`Batch #${record?.fg_adjustment?.custom_batch_number}`} className="job-works__table-subtext" />}
              <div className="job-works__table-subtext">
                {record?.process_name}
              </div>
              <div className="job-works__table-subtext">
                {`${record?.target_quantity} ${record?.fg_uom_info?.uqc ? record?.fg_uom_info?.uqc?.toProperCase() : record?.sfg_uom_info?.uqc?.toProperCase()}`}
              </div>
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Machine',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (

          <div className="bordered-table-input min-width-70">
            {
              !record?.machine_resource_group && record?.seller_info ? (
                <Fragment>
                  <div style={{ color: '#333333', fontWeight: '500', marginBottom: '5px' }}>
                    <FontAwesomeIcon icon={faUser} />
                    &nbsp;
                    <span>Subcontractor</span>
                  </div>
                  {record?.seller_info ? `${record?.seller_info?.internal_slr_code} - ${record?.seller_info?.seller_name}` : ''}
                </Fragment>
              ) : (
                <Fragment>
                  {
                    record?.machine_resource_group ? (
                      <Fragment>
                        <div style={{ color: '#333333', fontWeight: '500', marginBottom: '5px' }}>
                          <FontAwesomeIcon icon={faIndustry} />
                          &nbsp;
                          <span>{record?.machine_resource_group?.resource_group_name}</span>
                        </div>
                        <span
                          className="resource-status__icon"
                          style={{
                            color: (['ONLINE'].includes(record?.machine_resource_group?.allocated_machine?.status) && record?.machine_resource_group?.allocated_machine?.occupancy_status === 'IN_USE') ? '#EE404C' : machineStatus(record?.machine_resource_group?.allocated_machine?.status)?.color,
                            marginRight: '5px',
                          }}
                        >
                          {['OFFLINE'].includes(record?.machine_resource_group?.allocated_machine?.status)
                            && <FontAwesomeIcon icon={faPowerOff} />}
                          <Tooltip title="This machine is Online and available for use">
                            {['ONLINE'].includes(record?.machine_resource_group?.allocated_machine?.status) && record?.machine_resource_group?.allocated_machine?.occupancy_status === 'FREE'
                              && <FontAwesomeIcon icon={faPowerOff} />}
                          </Tooltip>
                          <Tooltip title="This machine currently in use">
                            {['ONLINE'].includes(record?.machine_resource_group?.allocated_machine?.status) && record?.machine_resource_group?.allocated_machine?.occupancy_status === 'IN_USE'
                              && <FontAwesomeIcon icon={faClock} />}
                          </Tooltip>
                          {['BREAKDOWN'].includes(record?.machine_resource_group?.allocated_machine?.status) && <FontAwesomeIcon icon={faPlugCircleXmark} />}
                        </span>
                        {record?.machine_resource_group?.allocated_machine ? `#${record?.machine_resource_group?.allocated_machine?.resource_number} - ${record?.machine_resource_group?.allocated_machine?.resource_name}` : ''}

                      </Fragment>
                    ) : '-'
                  }
                </Fragment>
              )
            }
          </div>
        ),
      },
      {
        title: 'Operator',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (record) => {
          return ({
            children: (
              <div className="min-width-70">
                <OperatorSelector record={record} />
              </div>
            ),
          });
        },
      },
      {
        title: 'No. of Man Power',
        render: (record) => (
          <div className="number-of-man-power__wrapper min-width-115">
            {record.no_of_man_power ? record.no_of_man_power : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Dependent Job Cards',
        render: (record) => (
          <div className="min-width-150">
            <div className={record?.incomplete_previous_job_works?.length ? 'job-work__warning-column' : ''}>
              {
                record?.incomplete_previous_job_works?.map((item) => (
                  // eslint-disable-next-line react/jsx-key
                  <span>
                    <FontAwesomeIcon icon={faCircleExclamation} style={{ color: '#EE404C' }} />
                    <span style={{ marginLeft: '2px' }}>{item?.jw_number}</span>
                    &nbsp;
                    <span>
                      <H3Text text={item?.status?.toProperCase()?.replaceAll('_', ' ')} className="job-work__warning-column-status" />
                    </span>
                  </span>
                ))
              }
            </div>
            {
              record?.rm_lines?.filter((item) => item?.issued_rm_qty === 0)?.length > 0 && (
                <div style={{ marginTop: '3px' }}>
                  <H3Text text={`${record?.rm_lines?.filter((item) => item?.issued_rm_qty === 0)?.length} RM Not Issued`} className="job-work__warning-column-status" />
                </div>
              )
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Created Date',
        render: (record) => (
          <div className="min-width-85">
            {dayjs(record?.created_at).format('DD/MM/YYYY')}
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : '')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Estimated Lead Time',
        render: (record) => (
          <div className="min-width-150">
            <H3Text text={(record?.lead_time_in_min ? `${convertMinutesToTime(record?.lead_time_in_min)}` : '00:00:00')} style={{ fontSize: '16px', marginTop: '3px' }} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Remarks',
        render: (record) => {
          return (
            <div className="jw-list-remarks__wrapper min-width-70">
              <textarea
                rows="3"
                value={record?.remarks}
                className="jw__remarks"
                placeholder="No remarks..."
                disabled
              />
            </div>
          )
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Time Lapsed (Hours)',
        render: (record) => {
          return (
            <div className="min-width-150">
              <JobWorkAction record={record} />
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        fixed: 'right',
      },
      {
        title: '',
        key: 'action',
        className: 'list__actions-column',
        fixed: 'right',
        render: (text, record) => (
          <div className="list__actions list__actions__single">
            <div
              className="list__actions-button"
              onClick={() => {
                setSelectedJobWork(record?.production_route_line_id);
              }}
            >
              View
            </div>
          </div>
        ),
        responsive: ['md', 'lg', 'xxl'],
        hidden: isPortrait,
      },

    ];
    jobWorkColumns.push(...fixedColumn);
    return jobWorkColumns.filter((item) => !item.hidden);
  };

  return (
    <Fragment>
      <PRZModal
        isOpen={showPRZModal}
        onClose={() => {
          setShowPRZModal(false);
          setCurrentProduct(null);
        }}
        entityType="product"
        documentId={currentProduct}
      />
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedJob?.jw_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          description={selectedJob?.remarks}
          descriptionLabel="Remarks"
          documentData={selectedJob}
          fields={ListScreenKeys({
            documentData: selectedJob, machineStatus,
          })}
        />
      </Drawer>
      <Table
        scroll={!isMobileOrPortrait && !!jobWorks?.job_works?.length ? { x: 'max-content', y: 'calc(100dvh - 160px)' } : { x: 'max-content' }}
        sticky={!isMobileOrPortrait && !!jobWorks?.job_works?.length}
        loading={getJobWorksLoading || updateTemplateRouteStatusLoading || updateAssigneeLoading || updateJobWorkLoading}
        showHeader
        size="small"
        columns={getJobWorkColumns()}
        dataSource={jobWorks?.job_works?.map((item, index) => ({ ...item, key: index + 1 })) || []}
        pagination={
          {
            defaultCurrent: currentPage,
            current: currentPage,
            total: jobWorks ? jobWorks?.count : 0,
            pageSize: limit,
            showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              if (pageSize !== limit) {
                setCurrentPage(1);
                setLimit(pageSize);
              }
              setSelectedRowKeys(null);
              setSelectedRows([]);
            },
            position: ['bottomLeft'],
            showSizeChanger: true,
            pageSizeOptions: [10, 25, 50, 100],
          }
        }
        bordered
        rowClassName={(record) => (((['OFFLINE', 'BREAKDOWN'].includes(record?.machine?.status) || record?.incomplete_previous_job_works?.length > 0 || record?.rm_lines?.filter((item) => item?.issued_rm_qty === 0)?.length || record?.machine?.occupancy_status === 'IN_USE') && record?.status !== 'IN_PROGRESS') ? 'row-warning' : `${record?.status === 'IN_PROGRESS' ? 'row-running' : ''}`)}
        rowSelection={!isMobileOrPortrait ? {
          onChange: (rowKeys, rows) => {
            setSelectedRowKeys(rowKeys);
            setSelectedRows(rows);
          },
          selectedRowKeys,
          getCheckboxProps: (record) => ({
            disabled: ['COMPLETED', 'VOID'].includes(record.status) || !record?.subcontractor_seller_id || selectedTenant?.length !== 1,
          }),
        } : false}
      />
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, DepartmentReducers, JobWorkReducers, TemplateRouteReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  departments: DepartmentReducers.departments,
  jobWorks: JobWorkReducers.jobWorks,
  updateJobWorkLoading: JobWorkReducers.updateJobWorkLoading,
  getJobWorksLoading: JobWorkReducers.getJobWorksLoading,
  updateTemplateRouteStatusLoading: TemplateRouteReducers.updateTemplateRouteStatusLoading,
  updateAssigneeLoading: TemplateRouteReducers.updateAssigneeLoading,
  getJobOperatorsLoading: JobWorkReducers.getJobOperatorsLoading,
  jobOperators: JobWorkReducers.jobOperators,
  orgUsers: TenantReducers.orgUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getJobWorks: (payload, callback) => dispatch(JobWorkActions.getJobWorks(payload, callback)),
  updateJobWork: (payload, callback) => dispatch(JobWorkActions.updateJobWork(payload, callback)),
  getJobOperators: (payload, callback) => dispatch(JobWorkActions.getJobOperators(payload, callback)),
  updateTemplateRouteStatus: (payload, callback) => dispatch(TemplateRouteActions.updateTemplateRouteStatus(payload, callback)),
  updateAssignee: (payload, callback) => dispatch(TemplateRouteActions.updateAssignee(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(JobWorksList));
